import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import ReactJson from "react-json-view";

import { getByDotNotation } from "./utils.js";

const useStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
		height: "100%",
		background: "white",
		color: theme.palette.primary.main,
		padding: "1%",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		backgroundColor: "#1d1f21",
	},
}));

const randomValue = {
	string: "this is a test ...",
	integer: 42,
	array: [1, 2, 3, "test"],
	float: 3.141_59,
	undefined,
	object: {
		"first-child": true,
		"second-child": false,
		"last-child": null,
	},
	string_number: "1234",
	date: "Wed, Mar 17, 2021, 02:59 PM",
};

const Json = ({
	// itemWidth,
	// itemHeight,
	variables,
	// calculateFontSize,
	mode,
	liveVariables = {},
}) => {
	const classes = useStyles();
	const [value, setValue] = useState({});

	useEffect(() => {
		if (mode === "view") {
			const liveValue = getByDotNotation(liveVariables, variables?.variable?.value);
			if (!liveValue) {
				setValue(liveVariables[variables?.variable?.value] || randomValue);
				return;
			}

			setValue(liveValue);
		} else {
			setValue(randomValue);
		}
	}, [mode, liveVariables, variables?.variable?.value]);

	return (
		<Grid
			item
			className={classes.root}
			style={{
				fontSize: "14px",
				height: "100%",
				overflow: "auto",
			}}
		>
			<ReactJson
				enableClipboard
				src={value}
				theme="google"
				style={{ width: "100%", height: "auto" }}
				iconStyle="triangle"
				displayObjectSize={false}
				displayDataTypes={false}
				quotesOnKeys={false}
				displayArrayKey={false}
			/>
		</Grid>
	);
};

export default Json;
